import { render, staticRenderFns } from "./dragSet.vue?vue&type=template&id=6d37e42d&scoped=true"
import script from "./dragSet.vue?vue&type=script&lang=js"
export * from "./dragSet.vue?vue&type=script&lang=js"
import style0 from "./dragSet.vue?vue&type=style&index=0&id=6d37e42d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d37e42d",
  null
  
)

export default component.exports